import { render, staticRenderFns } from "./DataMonitorsPage.vue?vue&type=template&id=3bc995ee&scoped=true"
import script from "./DataMonitorsPage.vue?vue&type=script&lang=js"
export * from "./DataMonitorsPage.vue?vue&type=script&lang=js"
import style0 from "./DataMonitorsPage.vue?vue&type=style&index=0&id=3bc995ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc995ee",
  null
  
)

export default component.exports